module.exports = __webpack_public_path__ + "static/media/icon-O2O-system3.43d90181.png";